// extracted by mini-css-extract-plugin
export default {"unit":"AbbrUnit--unit--zfiTg"};